<template>
  <div class="max-w-5xl mx-auto mt-5">
    <div class="">
      <div class="bg-white shadow sm:rounded-lg">
        <div class="px-4 py-5 sm:p-6">
          <h3
            class="text-lg leading-6 font-medium text-gray-900"
            id="renew-headline"
          >
            Whatsapp Chat
          </h3>
          <div class="mt-2 sm:flex sm:items-start sm:justify-between">
            <div class="max-w-xl text-sm leading-5 text-gray-500">
              <p id="renew-description">
                Enable or Disable WhatsApp chat on your store
              </p>
            </div>
            <div
              class="mt-5 sm:mt-0 sm:ml-6 sm:flex-shrink-0 sm:flex sm:items-center"
            >
              <VSwitch :value="config.isEnabled" @input="handleSwitch" />
            </div>
          </div>
        </div>
      </div>
      <ChatConfigureForm
        :config="config"
        v-if="config.isEnabled"
        @save="updateConfig"
      />
      <div v-if="config.isEnabled">
        <OfficeHours
          v-if="config.isEnabled"
          :config="config"
          @save="updateConfig"
        />
        <CalloutCard
          v-if="config.isEnabled"
          :config="config"
          @save="updateConfig"
        />
        <ChatWidget
          v-if="config.isEnabled"
          :config="config"
          @save="updateConfig"
        />
      </div>

      <Notification :text="notificationText" :show="showNotification" />
    </div>
  </div>
</template>

<script>
import VSwitch from "../components/Common/VSwitch";

import ChatConfigureForm from "../components/Common/ChatConfigureForm";
import Notification from "../components/Common/Notification";

import OfficeHours from "../components/Chat/OfficeHours";
import ChatWidget from "../components/Chat/ChatWidget";
import CalloutCard from "../components/Chat/CalloutCard";

export default {
  name: "Chat",
  components: {
    VSwitch,
    ChatConfigureForm,
    Notification,
    OfficeHours,
    ChatWidget,
    CalloutCard
  },

  data() {
    return {
      config: {},
      notificationText: "",
      showNotification: false
    };
  },
  computed: {
    hasAccessToChatWidget() {
      const store = this.$store.getters.getStore;
      return store.hasAccessToChatWidget;
    }
  },
  created() {
    this.init();
    this.updateOnboadingFlag();
  },
  methods: {
    async init() {
      const response = await this.$store.dispatch("getChatConfig");
      this.config = response.config;
    },
    updateConfig() {
      console.log(this.config);
      const chatConfig = { ...this.config };
      delete chatConfig.scriptTagId;
      delete chatConfig.isEnabled;
      this.$store
        .dispatch("updateChatConfig", { requestParams: chatConfig })
        .then(() => {
          this.displayNotification("settings updated");
        });
    },
    activateChat() {
      this.$store.dispatch("activateChat").then(response => {
        if (response.authUrl) {
          if (window.top) {
            window.top.location = response.authUrl;
          } else {
            window.location.href = response.authUrl;
          }
        } else {
          this.config = response.config;
        }
      });
    },
    deactivateChat() {
      this.$store.dispatch("deactivateChat").then(response => {
        this.config = response.config;
      });
    },
    handleSwitch(value) {
      if (value) {
        this.activateChat();
        return;
      }
      this.deactivateChat();
    },
    displayNotification(text) {
      this.showNotification = true;
      this.notificationText = text;
      setTimeout(() => {
        this.showNotification = false;
      }, 3000);
    },
    updateOnboadingFlag() {
      this.$store.dispatch("updateOnboardingFlag", {
        requestParams: {
          flag: "isChatPageVisited"
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
